import type { KeyboardEvent } from "react";

type PreventNonNumericInput = (
  e: KeyboardEvent<Element>,
  noDecimals?: boolean,
) => void;

export const preventNonNumericInput: PreventNonNumericInput = (
  e,
  noDecimals = false,
) => {
  if (
    e.key === "e" ||
    e.key === "ArrowUp" ||
    e.key === "ArrowDown" ||
    e.key === "E" ||
    e.key === "-" ||
    e.key === "+" ||
    (noDecimals && (e.key === "." || e.key === ","))
  ) {
    e.preventDefault();
  }
};
